import t from "styled-components";
import e from "../../utils/colors.js";
const l = t.table`
  font-weight: lighter;
  font-size: 1rem;
  line-height: 1.75;
  width: 100%;
  margin: 30px 0;
  border-collapse: collapse;
  border-spacing: 0;
  text-align: left;

  li {
    font-size: 1rem;
  }
`, r = t.th`
  background-color: ${e.blueGrey};
  font-weight: 700;
  color: ${e.white};
  border-top: none;
  padding: 18px 30px;
  text-align: left;
  vertical-align: top;
  position: relative;
`, n = t.tr``, a = t.td`
  padding: 18px 30px;
  text-align: left;
  vertical-align: top;
  position: relative;
`;
export {
  l as Table,
  r as TableHeader,
  a as TableItem,
  n as TableRow
};
